import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_2 = { class: "ms-2 flex-fill" }
const _hoisted_3 = {
  key: 0,
  class: "text-warning text-label mb-0 mt-1 text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_5 = { class: "text-subtitle mb-0" }
const _hoisted_6 = {
  key: 2,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_7 = {
  key: 1,
  class: "text-subtitle mb-0"
}
const _hoisted_8 = { class: "text-paragraph" }
const _hoisted_9 = { class: "d-flex py-4 align-items-center justify-content-between border-bottom" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, "Período", -1)
const _hoisted_11 = { class: "text-subtitle mb-0" }

import { ref } from "vue";
import type { Appointment } from "@phurshell/psiapp-frontend-core/domain";
import { useRouter } from "vue-router";
import { toggleModal } from "@/utils/Helper";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { syncSession } from "@/di/useCases";
import { appointmentRepo } from "@/di/repositories";
import { useUpdateAppointment, useInvalidateAppointments } from "@/composables/useAppointments";
import { closeOffCanvas } from "@/views/OffcanvasViews/OffcanvasViewsConfig";
import paths from "@/router/paths";

const modalId = "acceptance_modal";

export default /*#__PURE__*/_defineComponent({
  __name: 'Actions',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

const isSubmittingCancel = ref(false);
const isSubmittingConfirm = ref(false);
const comingIn = ref(false);

const { mutateAsync: updateAppointment } = useUpdateAppointment();
const invalidateAppointments = useInvalidateAppointments();

function handleCancelPressed() {
  toggleModal("cancel_appointment_modal");
}

function handleAccept() {
  if (props.item.recurrency) {
    handleAcceptPressed();
  } else {
    handleConfirmPressed();
  }
}

async function handleScheduledAppointment() {
  try {
    if (props.item.type === "imediate") {
      comingIn.value = true;
      await appointmentRepo.getAppointmentById(props.item.id);
      handleGoToRoom();
    } else {
      handleGoToRoom();
    }
  } catch (error) {
    console.error(error);
  } finally {
    comingIn.value = false;
  }
}

function handleGoToRoom() {
  router.push(`${paths.appointments.room}/${props.item.id}`);
  closeOffCanvas();
}

async function handleAcceptPressed() {
  try {
    if (isSubmittingConfirm.value || isSubmittingCancel.value) return;
    const params = {
      interval: props.item.recurrency.interval,
      frequency: props.item.recurrency.frequency,
      date: props.item.recurrency.reference_date,
    };
    const res = await appointmentRepo.recurrenciesVerification(params);
    if (res.can_schedule) {
      toggleModal(modalId);
    } else {
      alert(
        res.message ??
          "Ops! Horário já possui outras sessões agendadas. O horário solicitado coincide com uma sessão já agendada no futuro",
      );
    }
  } catch (error) {
    console.log(error);
  }
}

async function handleConfirmPressed() {
  try {
    if (isSubmittingConfirm.value || isSubmittingCancel.value) return;
    isSubmittingConfirm.value = true;

    await updateAppointment({ id: props.item.id, status: "agendado" });
    EventBus.$emit(EventBusNames.UPDATE_APPOINTMENTS);
    await syncSession.execute();

    if (props.item.recurrency) toggleModal(modalId);
  } catch (error) {
    console.error(error);
  } finally {
    isSubmittingConfirm.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.item.status === 'aguardando')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Button, {
            marginVertical: false,
            fullWidth: "",
            onOnClick: handleCancelPressed,
            label: "Cancelar",
            outline: "",
            outlineColor: "danger",
            loading: isSubmittingCancel.value,
            class: "me-2"
          }, null, 8, ["loading"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              marginVertical: false,
              fullWidth: "",
              onOnClick: handleAccept,
              label: "Aceitar sessão",
              loading: isSubmittingConfirm.value,
              disabled: _ctx.item.payment_requires_action
            }, null, 8, ["loading", "disabled"]),
            (_ctx.item.payment_requires_action)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Aguardando autenticação do pagamento pelo paciente "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item.status === 'agendado' || _ctx.item.status === 'em andamento')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.item.status === 'em andamento' ? `Sessão iniciada` : `Aguardando início`), 1),
          _createVNode(_component_Button, {
            marginVertical: false,
            onOnClick: handleScheduledAppointment,
            label: "Iniciar sessão",
            disabled: !_ctx.item.can_enter,
            loading: isSubmittingConfirm.value
          }, null, 8, ["disabled", "loading"])
        ]))
      : _createCommentVNode("", true),
    (
      _ctx.item.type === 'imediate' &&
      (_ctx.item.status === 'em andamento' || _ctx.item.status === 'pendente')
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.item.status === 'pendente')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                marginVertical: false,
                fullWidth: "",
                outline: "",
                class: "me-2",
                onOnClick: handleCancelPressed,
                loading: isSubmittingCancel.value,
                label: "Recusar"
              }, null, 8, ["loading"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, "Sessão iniciada")),
          _createVNode(_component_Button, {
            marginVertical: false,
            fullWidth: _ctx.item.status === 'pendente',
            class: _normalizeClass({ 'ms-2': _ctx.item.status === 'pendente' }),
            label: _ctx.item.status === 'pendente' ? 'Iniciar sessão' : 'Retomar sessão',
            loading: comingIn.value,
            disabled: !_ctx.item.can_enter,
            onOnClick: handleScheduledAppointment
          }, null, 8, ["fullWidth", "class", "label", "loading", "disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalComponent, {
      backdrop: "false",
      id: modalId,
      title: "Deseja aceitar esta sessão e as futuras?"
    }, {
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_8, " Aceitando essa sessão você estará aceitando sessões que acontecerão " + _toDisplayString(_ctx.item.recurrency?.frequencyText), 1),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.item.recurrency?.frequencyLabel), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          outline: "",
          label: "Não, voltar",
          onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleModal)(modalId)))
        }),
        _createVNode(_component_Button, {
          label: "Aceitar esta e as próximas sessões",
          onOnClick: handleConfirmPressed,
          loading: isSubmittingConfirm.value
        }, null, 8, ["loading"])
      ]),
      _: 1
    })
  ], 64))
}
}

})